<div class="d-flex flex-column gap-3">
  <div>
    <h1 class="h4 mb-1">{{ 'help-curation.title' | translate }}</h1>
    <p class="text-secondary mb-0">{{ 'help-curation.intro' | translate }}</p>
  </div>

  <div class="row">
    <div class="col-md-8 col-xl-9 mb-3">
      <lib-help-curation-list></lib-help-curation-list>
    </div>

    <div class="col-md-4 col-xl-3">
      <lib-help-odoo-import></lib-help-odoo-import>
    </div>
  </div>
</div>
